export { AddDeviceToEntraGroupToolImpl } from "./src/addDeviceToEntraGroup.tool";
export { addDeviceToEntraGroup } from "./src/model/graphApi";
